declare global {
    interface Window {
        onSpotifyWebPlaybackSDKReady: () => void;
    }
}

export interface authResponse {
  tokenData: tokenData;
  refreshToken: boolean;
  url?: string;
}

export interface tokenData {
  access_token: string;
  token_type: string;
  expires_in: number,
  refresh_token?: string;
  scope: string;
}

interface SpotifyEmbedController {
  loadUri: (uri: string) => void;
  play: () => void;
}

interface SpotifyIframeApi {
  createController: (
      element: HTMLElement | null,
      options: { uri: string },
      callback: (EmbedController: SpotifyEmbedController) => void
  ) => void;
}

declare global {
  interface Window {
      onSpotifyIframeApiReady: (IFrameAPI: SpotifyIframeApi) => void;
  }
}

import barba from '@barba/core';
import Home from './Home';
import Tour from './Tour';
import Music from './Music';
import About from './About';
import Contact from './Contact';
import News from './News';

class Site { 

    body: HTMLElement | null;
    pages: any[];
    playerContainer: HTMLElement | null;
    element: HTMLElement | null;
    musicContainer: HTMLElement | null;
    mainContainer: HTMLElement | null;
    mobileMenuToggle: HTMLElement | null;
    mobileMenu: HTMLElement | null;
    mobileMenuClose: HTMLElement | null;
    subscribeForm: HTMLFormElement | null;
    subscribeFormPopup: HTMLFormElement | null;
    subEmail: HTMLInputElement | null;
    subEmailPopup: HTMLInputElement | null;
    thankYou: HTMLElement | null;

    constructor() {
        this.setupRouting.bind(this);
        this.setupRouting();      
        this.body = document.querySelector('body');
        this.pages = [];
        this.playerContainer = document.querySelector('.player-container');
        this.musicContainer = document.querySelector('.container-music');
        this.mainContainer = document.querySelector('.site-container');
        this.element = document.getElementById('embed-iframe');
        this.mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
        this.mobileMenu = document.querySelector('.mobile-menu');
        this.mobileMenuClose = document.querySelector('.mobile-menu-close');

        this.subscribeForm = document.querySelector('.subscribeForm');
        this.subscribeFormPopup = document.querySelector('.subscribeFormPopup');
        this.subEmail = document.querySelector('.subEmail');
        this.subEmailPopup = document.querySelector('.subEmailPopup');

        this.thankYou = document.getElementById('sub-thanks');
       
        if (this.subscribeForm) {
          this.subscribeForm.addEventListener('submit', this.submitForm.bind(this));
        }

        if (this.subscribeFormPopup) {
          this.subscribeFormPopup.addEventListener('submit', this.submitForm.bind(this));
        }
        
        this.initPage();
        this.updateNavigationActiveState();
    }

    updateNavigationActiveState() {
        const currentPath = document.location.pathname;
        const navLinks = document.querySelectorAll('.site-navigation a[data-page]');
        
        navLinks.forEach(link => {
            const page = link.getAttribute('data-page');
            const href = link.getAttribute('href');
            
            // Remove active class from all links
            link.classList.remove('active');
            
            // Add active class if the current path matches the link's page
            if (currentPath === '/' && page === 'home') {
                link.classList.add('active');
            } else if (currentPath.includes(`/${page}`)) {
                link.classList.add('active');
            }
        });

        setTimeout(() => {
          this.body?.classList.remove('is-locked');
        }, 300);

        this.mobileMenu?.classList.remove('is-open');
        this.playerContainer?.classList.remove('hidden');
    }

    setupRouting() {
      const _self = this;

      barba.init({
          schema: {
              prefix: 'data-site',
              wrapper: 'app'
          },
          views: [{
            namespace: 'site',
            beforeLeave() {
              _self.destroyPage();
            },
            afterEnter() {
              window.scrollTo({
                  top: 0
              });
            }
          }]
      });

      barba.hooks.before(() => {
        // document.querySelector('.site-wrapper')?.classList.add('is-leaving');
        // document.querySelector('.preloader')?.classList.add('show');
        this.musicContainer?.classList.add('is-hidden');

        console.log(document.location.pathname, "pathname");

        if (document.location.pathname !== '/music') {
          this.mainContainer?.classList.remove('is-hidden');
        }

        if (document.location.pathname === '/music') {
          console.log("removing showing music, hiding main");
          this.musicContainer?.classList.remove('is-hidden');
        }

      });

      barba.hooks.after(() => {
        this.initPage();
        

        this.body?.classList.remove('is-locked');
        this.playerContainer?.classList.remove('is-open');


        if (document.location.pathname !== '/') {
          this.body?.classList.remove('overflow-y-locked');
        }

        if (document.location.pathname === '/') {
          this.body?.classList.add('overflow-y-locked');
        }

        setTimeout(() => {
          this.updateNavigationActiveState();
          // document.querySelector('.site-wrapper')?.classList.remove('is-leaving');
          // document.querySelector('.preloader')?.classList.remove('show');
        }, 300);
      });
    }

    loadPages(){
      this.pages = [];
      this.pages.push(new Home());
      this.pages.push(new Tour());
      this.pages.push(new Music());
      this.pages.push(new About());
      this.pages.push(new Contact());
      this.pages.push(new News());
    }

    destroyPage() {
      this.pages.forEach(page => {
        page.destroy();
      });
    }

    initPage() {
      this.setupMobileMenuToggle();
      this.loadPages();
    }

    setupMobileMenuToggle() {
      this.mobileMenuToggle?.addEventListener('click', () => {
        this.body?.classList.add('is-locked');
        this.mobileMenu?.classList.add('is-open');
        this.playerContainer?.classList.add('hidden');
      });

      this.mobileMenuClose?.addEventListener('click', () => {
        setTimeout(() => {
          this.body?.classList.remove('is-locked');
        }, 300);

        this.mobileMenu?.classList.remove('is-open');
        this.playerContainer?.classList.remove('hidden');
      });
    }

    submitForm(e: any) {
      e.preventDefault();

      if (!this.subEmail?.value && !this.subEmailPopup?.value) {
          return false;
      }

      const send = async () => {    
        if (this.thankYou) {
          this.thankYou.style.display = 'block';
        }

        await fetch(
            `/.netlify/functions/signup`,
            {
              method: "POST",
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                email: this.subEmail?.value || this.subEmailPopup?.value,
              }),
            }
          );

        localStorage.setItem('signupShown', 'true');
      };

      send();
      return false;
    }
    
}

export default Site;